<template>
    <div class="row">
        <input-date-time class="col-12 col-md-6" label="Data de previsão de emissão" v-model="form.previsaoEmissao" ref="previsao" required/>
        <input-date-time class="col-12 col-md-6" label="Data de emissão" v-model="form.emissao" ref="emissao"/>
        <div class="mt-2 col-12">
            <upload v-if="!form.nomeCobrancaAWS"
                id="boleto"
                type=".pdf"
                :arquivo-download-nome="form.nomeCobrancaAWSUP"
                :arquivo-download="form.cobrancaBase64"
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeCobrancaAWSUP = nomeArquivo;
                    form.cobrancaBase64 = file;
                    this.$forceUpdate();
                }"
                selecioneArquivo="Selecione o boleto de cobrança"
                tituloArquivo="Arraste o boleto de cobrança"
            />

            <template v-if="form.nomeCobrancaAWS">
                <div>
                    Boleto de cobrança
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="removerArquivoParcela(false)" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="downloadArquivoParcela(form.id, false)" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeCobrancaAWS}}
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="mt-2 col-12">
            <upload v-if="!form.nomeComprovanteAWS"
                id="comprovante"
                type=".pdf"
                :arquivo-download-nome="form.nomeComprovanteAWSUP"
                :arquivo-download="form.comprovanteBase64"
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeComprovanteAWSUP = nomeArquivo;
                    form.comprovanteBase64 = file;
                    this.$forceUpdate();
                }"
                selecioneArquivo="Selecione o comprovante de pagamento"
                tituloArquivo="Arraste o comprovante de pagamento"
            />

            <template v-if="form.nomeComprovanteAWS">
                <div>
                    Comprovante de pagamento
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="removerArquivoParcela(true)" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="downloadArquivoParcela(form.id, true)" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeComprovanteAWS}}
                        </div>
                    </div>
                </div>
            </template>
        </div>

    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime.vue';
import Upload from '../../components/upload/Upload.vue';
import { FormMixin } from '../../common/mixins/FormMixin';
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import ContratoLicencaService from '@/common/services/contrato_licenca/contrato_licenca.service'
import helpers from '../../common/utils/helpers';

export default {
    mixins: [FormMixin],
    props : {
        form : {
            required : true
        }
    },
    components : {
        InputDateTime,
        Upload
    },
    methods: {
        downloadArquivoParcela: function (itemId, isComprovante) {
            this.$store.dispatch(START_LOADING);

            ContratoLicencaService.downloadArquivoParcela(itemId, isComprovante)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            })
            .catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            })
            .finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        removerArquivoParcela: function(isComprovante){
            if(isComprovante) this.form.nomeComprovanteAWS = null;
            else this.form.nomeCobrancaAWS = null;
        },
    }
    
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>